import React from 'react';

const Alert = () => (
  <svg
    width="17px"
    height="18px"
    viewBox="0 0 17 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Payment-Links---Ordres-Copy"
        transform="translate(-1321.000000, -370.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="Group-8" transform="translate(265.000000, 257.000000)">
          <g id="Group-Copy-2" transform="translate(0.000000, 98.000000)">
            <g id="Group-5" transform="translate(1047.000000, 10.000000)">
              <g id="Cross-White" transform="translate(9.000000, 5.000000)">
                <g
                  id="Group"
                  transform="translate(8.389258, 9.000000) rotate(-345.000000) translate(-8.389258, -9.000000) translate(2.555925, 2.000000)"
                >
                  <path
                    d="M3.61233583,12.7370431 C3.94097523,13.4800218 4.68472078,14 5.54801887,14 C6.41131696,14 7.15503512,13.4800218 7.48370191,12.7370431 L3.61233583,12.7370431 Z"
                    id="Path"
                  />
                  <path
                    d="M5.54788193,1.33756427 C6.11757102,1.33756427 6.66458211,1.43808153 7.17220796,1.62210754 L7.17220796,1.55957868 C7.17220796,0.699622033 6.47258593,-4.87017833e-14 5.61265667,-4.87017833e-14 L5.48340846,-4.87017833e-14 C4.62345181,-4.87017833e-14 3.92382978,0.699622033 3.92382978,1.55957868 L3.92382978,1.62131326 C4.43118174,1.43783502 4.9780285,1.33756427 5.54788193,1.33756427 L5.54788193,1.33756427 Z"
                    id="Path"
                  />
                  <path
                    d="M10.6743717,11.9153761 L0.421666055,11.9153761 C0.227697873,11.9153761 0.050026086,11.7845667 0.00968223798,11.5948165 C-0.0302507766,11.406956 0.0553669213,11.2215332 0.229067318,11.1412837 C0.270287611,11.1145521 0.580549058,10.8976046 0.89116656,10.2412297 C1.46164993,9.03584424 1.5813942,7.33786946 1.5813942,6.12569157 C1.5813942,3.93855105 3.36076879,2.15923123 5.54788193,2.15923123 C7.72981856,2.15923123 9.50590648,3.92997832 9.51434226,6.10994295 C9.51453399,6.11517423 9.51464354,6.1204329 9.51464354,6.12569157 C9.51464354,7.33786946 9.63438781,9.03584424 10.2048712,10.2412297 C10.5154887,10.8976046 10.8257227,11.1145795 10.8669704,11.1412837 C11.0406708,11.2215332 11.1263159,11.4069286 11.0863555,11.5948165 C11.0460117,11.7845394 10.8683673,11.9153761 10.6743717,11.9153761 Z"
                    id="Combined-Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Alert;
